import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { createInviteDialogEvent } from '../../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../../analytics/functions';
import { translate } from '../../../../base/i18n/functions';
import Dialog from '../../../../base/ui/components/web/Dialog';
import { updateDialInNumbers } from '../../../actions.web';
import InviteContactsSection from './InviteContactsSection';
/**
 * Invite More component.
 *
 * @returns {React$Element<any>}
 */
function CallSIPDialog({ _dialIn, _inviteAppName, t, updateNumbers }) {
    /**
     * Updates the dial-in numbers.
     */
    useEffect(() => {
        if (!_dialIn.numbers) {
            updateNumbers();
        }
    }, []);
    /**
     * Sends analytics events when the dialog opens/closes.
     *
     * @returns {void}
     */
    useEffect(() => {
        sendAnalytics(createInviteDialogEvent('opened', 'dialog'));
        return () => {
            sendAnalytics(createInviteDialogEvent('closed', 'dialog'));
        };
    }, []);
    return (React.createElement(Dialog, { size: 'medium', hideButtons: true, titleKey: 'addPeople.vmp2sip' },
        React.createElement("div", { className: 'invite-more-dialog' },
            React.createElement(InviteContactsSection, null))));
}
/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code CallSIPDialog} component.
 *
 * @param {Object} state - The Redux state.
 * @param {Object} ownProps - The properties explicitly passed to the component.
 * @private
 * @returns {IProps}
 */
function mapStateToProps(state, ownProps) {
    const { inviteAppName } = state['features/base/config'];
    const dialIn = state['features/invite']; // @ts-ignore
    return {
        _dialIn: dialIn,
        _inviteAppName: inviteAppName
    };
}
/**
 * Maps dispatching of some action to React component props.
 *
 * @param {Function} dispatch - Redux action dispatcher.
 * @returns {IProps}
 */
const mapDispatchToProps = {
    updateNumbers: () => updateDialInNumbers()
};
export default translate(connect(mapStateToProps, mapDispatchToProps)(CallSIPDialog));
